module.exports = __webpack_public_path__ + "static/media/kalyan.9a1abecd.png";